<template>
  <detail
    :hiddenKeys="['project_domain', 'tenant', 'status']"
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo" />
</template>

<script>
import { getEnabledTableColumn } from '@/utils/common/tableColumn'
import { getFieldValueTypeText, getFieldConfigText } from '../constants'

export default {
  name: 'ResourceTypeSettingDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getEnabledTableColumn(),
      ],
    }
  },
  computed: {
    extraInfo () {
      const { attributes = [] } = this.data
      const extraInfo = [{
        title: this.$t('report.field_config'),
        items: [],
      }]
      attributes.map(item => {
        const col = {
          field: item.name,
          title: item.name,
          formatter: ({ row }) => {
            let str = `${getFieldValueTypeText(item)}`
            if (getFieldConfigText(item)) {
              str += ` (${getFieldConfigText(item)})`
            }
            return str
          },
        }
        extraInfo[0].items.push(col)
      })
      return extraInfo
    },
  },
}
</script>
